/**
 * @Author: maple
 * @Date: 2019-10-31 16:46:46
 * @LastEditors: maple
 * @LastEditTime: 2019-11-01 17:09:18
 */
import { createStore } from '@souche-f2e/muji';
import docsToTable from '@souche/docs-to-html-table';
import { fetchApi, fetchGroupApis } from '../services/docs-stable';

const state =  {
  api: {},
  inParamsTable: '',
  group: null
};

export default createStore({
  state,
  reducers: {
    UPDATE(state, { api }) {
      // 入参格式处理
      try {
        api.inParams = JSON.parse(api.inParams).join('\n');
      } catch (err) {
        api.inParams = '';
      }

      // 返回参数格式处理
      try {
        api.returnParams = JSON.parse(api.returnParams);
        api.returnParams = {
          code: 0,
          status: 200,
          message: 'success',
          data: api.returnParams
        };
      } catch (err) {
        api.returnParams = {
          code: 0,
          status: 200,
          message: 'success',
          data: {}
        };
      }

      try {
        api.returnCbParams = JSON.parse(api.returnCbParams);
      } catch (err) {
        api.returnCbParams = {};
      }

      // 入参转换成 HTML
      let inParamsTable;
      try {
        inParamsTable = docsToTable(api.inParams);
      } catch (ex) {
        inParamsTable = '<p>入参解析失败</p>';
      }

      return {
        ...state,
        inParamsTable,
        api
      }
    },
    CLEAN_API(state) {
      return {
        ...state,
        api: {}
      }
    },
    UPDATE_GROUP(state, { group }) {
      return {
        ...state,
        group
      }
    }
  },
  effects: {
    async fetch({ apiId }) {
      const body = await fetchApi({ apiId }).promise;

      const { success, data } = body;

      if (!success) {
        return;
      }

      const api = data;

      this.UPDATE({ api });
    },

    async fetchGroupApis({ groupId }) {
      const body = await fetchGroupApis({ groupId }).promise;

      const { success, data } = body;

      if (!success) {
        return;
      }

      const { groups } = data;
      let group = (groups || [])[0];
      if (!group) {
        group = { msg: `GROUP_ID: <${groupId}> 非法` };
      }
      
      this.UPDATE_GROUP({ group });
    }
  }
});